export const SET_TASKS = 'SET_TASKS';
export const SET_TASK = 'SET_TASK';
export const ADD_TASK = 'ADD_TASK';
export const EDIT_TASK = 'EDIT_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const CLEAR_TASKS = 'CLEAR_TASKS';
